/** Extensions expected to produce RAG chunks (Lens Intelligence). */
export const RAG_INDEXABLE_EXTENSIONS = new Set([
    'pdf',
    'fdf',
    'xfdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'csv',
    'ppt',
    'pptx',
    'rtf',
    'odt',
    'ods',
    'odp',
    'html',
    'htm',
    'mht',
    'txt',
    'md',
    'json',
    'xml',
]);

export const getFileExtension = name => {
    const base = String(name || '').split('/').pop() || '';
    const parts = base.split('.');
    if (parts.length < 2) return '';
    return parts.pop().toLowerCase();
};

export const isRagIndexableFileName = name => {
    const ext = getFileExtension(name);
    if (!ext) return true;
    return RAG_INDEXABLE_EXTENSIONS.has(ext);
};

export const makeUploadClientId = () =>
    `upl-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
